import React, { useState, useEffect, useMemo, createContext } from 'react';

import { localStorageKeys } from 'constants/localStorage';

import { initialState } from './initialState';

const AuthContext = createContext(initialState);
AuthContext.displayName = 'AuthContext';

const AuthContextProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    localStorage.setItem(localStorageKeys.authContext, JSON.stringify(state));
  }, [state]);

  const value = useMemo(() => ({ authContext: state, setAuthContext: setState }), [state]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export { AuthContext, AuthContextProvider };
